import type { Infer } from 'superstruct';
import { any, array, number, object, string } from 'superstruct';

import { workaround_softMask } from '@adflow/shared/util-data';
import { stringDate } from '@adflow/shared/util-superstruct';

export function getGMBLocationName(locationData: unknown) {
	const location = workaround_softMask(locationData, ViewGMBLocationDto);
	const rawLoc = location.rawLocation;

	const addressParts = [
		rawLoc.storefrontAddress?.addressLines?.[0],
		rawLoc.storefrontAddress?.locality,
		rawLoc.storefrontAddress?.administrativeArea,
		rawLoc.storefrontAddress?.postalCode,
	].filter((part) => !!part);
	const addressString = addressParts.join(', ');

	return `${location.avbId} :: ${location.name} :: ${addressString}`;
}

export const ViewGMBLocationDto = object({
	id: number(),
	googleId: string(),
	avbId: string(),

	name: string(),
	storeCode: string(),
	labels: array(string()),
	website: string(),

	rawLocation: any(),

	syncedAt: stringDate(),
	createdAt: stringDate(),
	updatedAt: stringDate(),
});

export type ViewGMBLocationDto = Infer<typeof ViewGMBLocationDto>;
